import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCZDTC-Nu13Enx0SqhcfoVxB_PaV8vNZKY",
    authDomain: "vivy-3e561.firebaseapp.com",
    projectId: "vivy-3e561",
    storageBucket: "vivy-3e561.firebasestorage.app",
    messagingSenderId: "793988922907",
    appId: "1:793988922907:web:04711c9e601c37f12742be",
    measurementId: "G-2QFYZVPTLC"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app); 